import type { ProntuarioPastSessionRecord } from '../types/prontuarioPastSession';
import { mapMedicalRecordSessionToPastSessionRecord } from './mapMedicalRecordSessionToPastSessionRecord';

export const buildProntuarioPastSessionListItems = ({
	recordSessions,
	platformSessions,
	currentPlatformSessionId,
}: {
	recordSessions?: MedicalRecords.MedicalRecordSession[] | null;
	platformSessions?: Sessions.Session[] | null;
	currentPlatformSessionId?: string | null;
}): ProntuarioPastSessionRecord[] => {
	const selectedDateByPlatformSessionId = new Map(
		(platformSessions ?? []).map((platformSession) => [
			platformSession.id,
			platformSession.selected_date,
		]),
	);

	return (recordSessions ?? [])
		.filter(
			(recordSession) =>
				recordSession.session_id !== currentPlatformSessionId,
		)
		.map((recordSession) =>
			mapMedicalRecordSessionToPastSessionRecord(
				recordSession,
				selectedDateByPlatformSessionId.get(recordSession.session_id),
			),
		);
};
